import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';

import { BaseEnumTranslationPipe } from '@iss/wo-common/pipes';

@Pipe({ name: 'contactRole', pure: false, standalone: true })
export class ContactRolePipe extends BaseEnumTranslationPipe<string> implements PipeTransform {
  protected readonly translationPrefix = 'iss-mc.enum.contact-role';

  public constructor(
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(translateService, changeDetectorRef);
  }
}
